import {Detail, FlexRow} from '@forecast-it/design-system';
import React from 'react';
import {NovaLabelChip} from './NovaLabelChip';

export interface RoutingDisclosureProps {
	agentName: string;
	reason?: string;
}

export const RoutingDisclosure = (props: RoutingDisclosureProps): JSX.Element => (
	<FlexRow>
		<NovaLabelChip tone="nova" data-cy="nova-agent-chip">
			{props.agentName}
		</NovaLabelChip>
		{props.reason && (
			<Detail data-cy="nova-routing-reason" color="medium">
				{props.reason}
			</Detail>
		)}
	</FlexRow>
);
